import { call, put, select, takeLatest } from 'redux-saga/effects';

import { CAMPAIGNS_PER_PAGE } from '../../utils/config';
import httpClient from '../../utils/httpClient';
import { getCampaignMap } from '../../utils/mapper';
import { CAMPAIGNS_GET_LIST_REQUEST, CAMPAIGNS_GET_SINGLE_REQUEST, CAMPAIGNS_LOAD_MORE_REQUEST } from '../actions/actionTypes';
import { getCampaignsError, getCampaignsStore, getSingleCampaignError, getSingleCampaignStore, loadMoreCampaignsError, loadMoreCampaignsStore } from '../actions/campaigns';
import { getList } from '../reducers/campaigns';

function getCampaignsApiCall(skip, profileId) {
  const take = CAMPAIGNS_PER_PAGE;
  return httpClient.get(`api/profiles/${profileId}/campaigns?take=${take}&skip=${skip}`);
}

// get list
function* getCampaignsListSaga({ payload }) {
  console.log('getCampaignsListSaga', payload);
  try {
    const { data } = yield call(getCampaignsApiCall, 0, payload);

    console.log('getCampaignsApiCall resp', data);

    let campaignsList = [];

    if (data && data.length) {
      data.forEach((camp) => campaignsList.push(getCampaignMap(camp)));
    }
    yield put(getCampaignsStore(campaignsList));
  } catch (error) {
    console.log('getCampaignsListSaga error', error.toString());

    yield put(getCampaignsError(error.Message ? error.Message : error.toString()));
  }
}

export function* getCampaignsListWatcher() {
  yield takeLatest(CAMPAIGNS_GET_LIST_REQUEST, getCampaignsListSaga);
}

// load more
function* getMoreCampaignsSaga() {
  try {
    const existingCampaigns = yield select(getList);
    const skip = existingCampaigns.length;

    const { data } = yield call(getCampaignsApiCall, skip);

    let campaignsList = [];

    if (data && data.length) {
      data.forEach((camp) => campaignsList.push(getCampaignMap(camp)));
    }

    yield put(loadMoreCampaignsStore(campaignsList));
  } catch (error) {
    console.log('getMoreCampaignsSaga error', error.toString());

    yield put(loadMoreCampaignsError(error.Message ? error.Message : error.toString()));
  }
}

export function* getMoreCampaignsWatcher() {
  yield takeLatest(CAMPAIGNS_LOAD_MORE_REQUEST, getMoreCampaignsSaga);
}

// get single
function getSingleCampaignApiCall(id, profileId) {
  return httpClient.get(`api/profiles/${profileId}/campaigns/${id}`);
}

function* getCampaignSingleSaga({ payload }) {
  try {
    const { data } = yield call(getSingleCampaignApiCall, payload);

    yield put(getSingleCampaignStore(data));
  } catch (error) {
    console.log('getCampaignSingleSaga error', error.toString());

    yield put(getSingleCampaignError(error.Message ? error.Message : error.toString()));
  }
}

export function* getCampaignSingleWatcher() {
  yield takeLatest(CAMPAIGNS_GET_SINGLE_REQUEST, getCampaignSingleSaga);
}
